import {
  JWTClaimsRole,
  permissionsEnumSchema,
  psychologistHeadlineEnumSchema,
} from "@mindlercare/schema";
import CONSTANTS from "core/constants";
import { Slot } from "../../core/types";

const UKStrategy = {
  patientCardTabs: {
    BOOKINGS: CONSTANTS.PATIENT_CARD_TABS.BOOKINGS,
    ICBT: CONSTANTS.PATIENT_CARD_TABS.ICBT,
    PROMOCODES: CONSTANTS.PATIENT_CARD_TABS.PROMOCODES,
    ACTIONS: CONSTANTS.PATIENT_CARD_TABS.ACTIONS,
  },
  patientSearchFields: {
    FIRSTNAME: CONSTANTS.SEARCH_TERMS.FIRSTNAME,
    LASTNAME: CONSTANTS.SEARCH_TERMS.LASTNAME,
    USER_ID: CONSTANTS.SEARCH_TERMS.USER_ID,
    EMAIL: CONSTANTS.SEARCH_TERMS.EMAIL,
  },
  psychologist: {
    userData: {
      rows: [
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_NAME,
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
          .EDITABLE_PHONE_AND_UNEDITABLE_EMAIL,
      ],
    },
    headlineKeys: [
      psychologistHeadlineEnumSchema.enum.counselling,
      psychologistHeadlineEnumSchema.enum.clinical_health,
      psychologistHeadlineEnumSchema.enum.applied,
      psychologistHeadlineEnumSchema.enum.lead,
      psychologistHeadlineEnumSchema.enum.clinical,
      psychologistHeadlineEnumSchema.enum.cbt_default,
    ],
    hasRequiredAdeli: false,
    hasPersonnummer: false,
  },
  specialities: {
    hasFilteredSpecialities: false,
  },
  slots: {
    isPayable: true,
  },
  marketHasStatisticsDashboard: true,
  slotTemplates: [
    CONSTANTS.SLOT_TEMPLATES.TECH_TEST,
    CONSTANTS.SLOT_TEMPLATES.LONG_VISIT,
    CONSTANTS.SLOT_TEMPLATES.BLOCKER,
    CONSTANTS.SLOT_TEMPLATES.MINDLER_ACADEMY,
    CONSTANTS.SLOT_TEMPLATES.DAILY_HUB, // = "Skills Swap"
    CONSTANTS.SLOT_TEMPLATES.CLINICAL_SUPERVISION,
    CONSTANTS.SLOT_TEMPLATES.LIVE_MANAGEMENT_30,
    CONSTANTS.SLOT_TEMPLATES.LIVE_MANAGEMENT_60,
    CONSTANTS.SLOT_TEMPLATES.REVISIT,
    CONSTANTS.SLOT_TEMPLATES.CONTRACTED_OTHER,
  ],
  patientCard: {
    status_label: "PAYMENT_STATUS",
  },
  showEditPatientDetails: true,
  showRevisitLabelSuffix: false,
  showInsuranceInfoPsychologist: false,
  showInsuranceInfoAdmin: true,
  showInsurancePlan: false,
  showSavedCardStatus: true,
  showExtraInfoPatientBookings: true,
  showSessionCountColumn: true,
  changeSlotStatus: {
    enabled: true,
    enabledForRoles: ["Psychologist"] as JWTClaimsRole[],
    enabledForPermission: permissionsEnumSchema.enum.EDIT_PATIENT_DETAILS,
    feeStatuses: [
      CONSTANTS.UPDATABLE_BOOKING_STATUS.LATE_CANCELED,
      CONSTANTS.UPDATABLE_BOOKING_STATUS.NO_SHOW,
      CONSTANTS.UPDATABLE_BOOKING_STATUS.ORGANIZER_NO_SHOW,
      CONSTANTS.UPDATABLE_BOOKING_STATUS.NO_SHOW_ALL,
    ] as Slot["status"][],
    getSlotStatuses: () => {
      return CONSTANTS.UPDATABLE_BOOKING_STATUS;
    },
  },
  clinicalGuidelinesHref:
    "https://drive.google.com/drive/folders/1zhwuTcNr8GNvV9ZTw1-9F5eoOxneICjP",
};

export default UKStrategy;
